module.exports = __webpack_public_path__ + "img/1566375648.3f14633b.jpg";